<template>
    <default-layout :title="PRODUCT_NAME2" @open="onOpen">
        <template v-slot:header>
            <Header :title="PRODUCT_NAME2" :readonly="true"/>
        </template>
        <template>
            <WizzardTour ref="wizardRef"/>
        </template>
        <template v-slot:sidebar>
            <div>
                <TotalePreventivo class="mb-3"/>
                <Itinerario href="itinerarioRef" @service="onDetailService"/>
            </div>
        </template>
        <template v-slot:footer>
            <div v-if="isMobile" class="menu-footer d-flex justify-content-between">
                <div class="custom-select" @click="onSelectMenu(1)">
                    <h5>Totale: {{totale}} &euro;</h5>
                </div>
                <div class="custom-select" @click="onSelectMenu(2)">
                    <h5>Itinerario</h5>
                </div>
            </div>
            <div v-if="open" class="bottom-menu-popup border-top">
                <div>
                    <div class="d-flex justify-content-end">
                        <div class="close">
                            <img src="../../assets/images/svg/blue/icone_close.svg" height="24px" @click="open = false"/>
                        </div>
                    </div>
                    <div class="content-area" style="max-height: 100%; overflow: auto">
                        <TotalePreventivo v-if="selected===1" class="mb-3"/>
                        <Itinerario v-if="selected===2" @service="onDetailService"/>
                    </div>
                </div>
            </div>
        </template>
    </default-layout>
</template>

<script>
import {mapGetters} from 'vuex'
import DefaultLayout from './layout/DefaultLayout'
import Header from '../widgets/pages/tour-accompagnati/layout/Header'
import WizzardTour from '../widgets/pages/tour-accompagnati/WizzardTour'
import TotalePreventivo from '../widgets/common/TotalePreventivo'
import Itinerario from '../widgets/pages/tour-accompagnati/ItinerarioTour'
import MobileDetector from '../common/MobileDetector'
import {formatMoney} from '../../utils/formatter'
import ContentUtils from '../utils/ContentUtils'

export default {
  name: 'Tour',
  mixins: [MobileDetector, ContentUtils],
  components: {Itinerario, TotalePreventivo, WizzardTour, Header, DefaultLayout},
  data () {
    return {
      selected: 1,
      open: false
    }
  },
  computed: {
    totale () {
      return formatMoney(this.summary.totalPrice)
    },
    summary () {
      return this.getSummary()
    }
  },
  methods: {
    ...mapGetters(['getSummary']),
    onChange: function (value) {
      this.$store.dispatch('modifySearch', value)
    },
    onOpen (event) {
      if (event === 'completaId') {
        this.$refs.wizardRef.completaPreventivo()
      } else {
        this.$refs.wizardRef.openTab(event)
      }
    },
    onSelectMenu (value) {
      this.selected = value
      this.open = true
    },
    onDetailService (item) {
      this.$refs.wizardRef.onShowTrasferimentoDetail(item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/pages/Tour.vue